export function isHeroSectionEmpty(props) {
    return (!props.backgroundImage ||
        !props.date ||
        !props.dateFrom ||
        !props.dateTo ||
        !props.description ||
        !props.title ||
        !props.subtitle ||
        !props.currencyCode);
}
